"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAction = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const { primaryGreen700 } = ui_components_1.baseColors;
exports.StyledAction = (0, styled_components_1.default)(ui_components_1.Button) `
  white-space: nowrap;
  align-self: flex-start;

  .MuiButton-endIcon {
    margin-left: 0.25rem;
  }

  &.action-add--text {
    padding: 0;
    min-width: 0;
  }

  &.menu--open.action-add--text {
    color: ${primaryGreen700};
    background-color: transparent;
    border-color: transparent;
  }

  &.menu--open.action-add--outlined {
    color: ${primaryGreen700};
    background-color: transparent;
    border-color: currentColor;
  }
`;
